<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid" style="background-color: #EEEEEE; color: #1a252f;">
    <div class="row" style="">
      <div class="store-head">
        <div class="back-link" @click="$router.back()">
          <i class="fas fa-chevron-left"></i>
        </div>
        <div class="category-title">
          <div style="margin-top: 16px; font-size: 20px;"> {{ $t('PURCHASE_HISTORY') }} </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="subscription-title"> {{ $t('SUBSCRIPTION')}}</div>
    </div>

    <div class="row">
      <div class="col-sm-3 mb-3" v-for="pack in tournamentPacks" :key="pack.bundle_id">
        <div class="purchase-card d-flex justify-content-between align-items-center p-2">
          <div class="pack-title">{{ pack.title }}</div>
          <div :class="{'pack-active': pack.is_subscribed, 'pack-disabled': ! pack.is_subscribed}"
               @click="openModal(pack)" style="font-weight: 650">
            {{  pack.is_subscribed ? $t('UNSUBSCRIBE_NOW') : $t('SUBSCRIBE_NOW') }}
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2" v-if="showHistory">
      <div class="purchase-history d-flex justify-content-between align-items-center"
           v-for="history in purchaseHistory"
           :key="history.id">
        <div class="d-flex align-items-center">
          <img src="@/assets/img/coin.png" alt="" style="margin-right: 14px;">
          <div class="purchase-details">
            <div class="pack-title">{{ history.title }}</div>
            <div class="user-coin">{{ $t('COINS') }} {{ history.coins }}</div>
          </div>
        </div>
        <div>
          <div class="purchase-date">{{ history.purchased_at }}</div>
          <div class="purchase-amount">{{ $t('BDT') }} {{ history.price }}</div>
        </div>
      </div>
    </div>
  </div>

  <UnsubscribeModal :modal-show="modalOpen" :slug="slug" v-if="modalOpen"/>

</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import _ from "lodash";
import UnsubscribeModal from "@/views/components/UnsubscribeModal";

export default {
  name: "PurchaseHistory",
  components: {
    Loader,
    UnsubscribeModal,
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      tournamentPacks: [],
      purchaseHistory: [],
      filterTypes: {
        'weekly': this.$t('WEEKLY'),
        'monthly': this.$t('MONTHLY'),
      },
      filterType: '',
      showHistory: false,
      modalOpen: false,
      slug: '',
    }
  },
  created() {
    this.filterType = Object.keys(this.filterTypes)[0];
    this.getTournamentPacks();
    this.getPurchaseHistory();
    this.emitter.on('subscribe-modal-close-event', (evt) => {
      this.slug = '';
      this.modalOpen = evt.eventContent;
      this.getTournamentPacks();
    });
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    getTournamentPacks() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/tournament-packs', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            this.tournamentPacks = response.data.packages;
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    getPurchaseHistory() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/bundles/purchase/history', {filter_type: this.filterType}, this.config)
          .then(response => {
            this.loaderActive = false;
            this.purchaseHistory = response.data.history;
            this.showHistory = ! _.isEmpty(this.purchaseHistory);
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    openModal(bundle) {
      if (bundle.is_subscribed) {
        this.slug = bundle.slug;
        this.modalOpen = true;
      }
    }
  }
}
</script>

<style scoped>

</style>
